import { render, staticRenderFns } from "./ListPriceCard.vue?vue&type=template&id=3e5a47a8&scoped=true&"
import script from "./ListPriceCard.vue?vue&type=script&lang=js&"
export * from "./ListPriceCard.vue?vue&type=script&lang=js&"
import style0 from "./ListPriceCard.vue?vue&type=style&index=0&id=3e5a47a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a47a8",
  null
  
)

export default component.exports